import { Suspense } from "react"
import Loader from "../Components/Loader/Loader"
import { Route, Routes } from "react-router-dom"
import Login from "../Pages/login"
import ForgetPassword from "../Pages/forgetPassword/ForgetPassword"
import PageNotFound from "../Pages/PageNotFound"
import Signup from "../Pages/signup/Signup"
import ChangePassword from "../Pages/ChangePass/ChangePassword"

export function PublicRoutes() {
  console.log("PublicRoutes", PublicRoutes)
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<Login />} />
        {/* <Route path="/login" element={<Login />} />
        <Route path="/lms" element={<Login />} /> */}
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Suspense>
  )
}